import React, { Component } from "react";
import { connect } from "react-redux";
import config from "./../../common/config";

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let self = this;
    const { isSecondary } = self.props;
    let sClassFixed = "";
    if (isSecondary) {
      sClassFixed = "m11c-loader__fullScreen "; //+'m11c-loader__hide';
      //return null;
    }
    return (
      <div className={"m11c-loader " + sClassFixed}>
        <svg className="m11c-loader__spin" viewBox="0 0 60 60">
          <circle
            className="m11c-loader__path"
            cx="30"
            cy="30"
            r="26"
            fill="none"
          ></circle>
        </svg>
      </div>
    );
  }
}
export default Loader;
